<div class="bg-light d-flex align-items-center">
  <div class="mt-2 mb-5 mx-3">
    <div class="card-body">
      <div class="d-flex flex-row justify-content-between">
        <h2 class="card-title">{{ 'legal_pages.consent_agreement_title' | translate }}</h2>
        <button type="button" class="btn-secondary btn close" (click)="close()">
          <span>&times;</span>
        </button>
      </div>
      <div [innerHTML]="'legal_pages.consent_agreement' | translate"></div>
    </div>
  </div>
</div>
